import axios from 'axios';
import { store } from '../../../../store/configureStore';

const surveyOverallS3IdFromItemId = (itemId) => {
  if (itemId.length === 1) {
    return itemId[0].surveyIds[0]
  } else
    return itemId[0].surveyIds[0] + '_' + itemId[1].surveyIds[0].slice(-12)
}

const generateOverallReportItemId = ({ surveyId, previousId }) => {
  const itemId = [{ surveyIds: [surveyId], role: 0 }];
  if (previousId) itemId.push({ surveyIds: [previousId], role: 1 })
  return itemId
}

const getReportWebLink = ({ itemId, templateId, v2 = true }) => {
  const _itemIdString = (typeof itemId === 'string') ? itemId : itemId[0].surveyIds[0]
  if (v2)
    return `/admin/reports/v2/${templateId}/${itemId}`
  else
    switch (templateId) {
      case "parent":
      case "adult":
      case "student":
        return `/admin/reports/${templateId}?pId=${itemId}`
      case "overall":
        return `/admin/reports/survey?id=${_itemIdString}`
      default:
        return null
    }
}

const getReportSignedUrl = async ({ id, template, parentAuthCode }) => {
  const idToken = parentAuthCode ? process.env.REACT_APP_PARTICIPANT_TOKEN : store.getState().auth.idToken;
  try {
    let s3Id = id;
    if (template === "overall") {
      s3Id = surveyOverallS3IdFromItemId(id)
    }
    const response = await axios({
      url: `${process.env.REACT_APP_API_URL}/reports/v2/${template}/${encodeURIComponent(s3Id)}`
        + (parentAuthCode ? `?parentAuthCode=` + encodeURIComponent(parentAuthCode) : ''),
      method: 'GET',
      headers: {
        Authorization: idToken
      },

    })
    return { url: response.data.url }
  } catch (error) {
    if (error.response) {
      console.error('HTTP Error Code:', error.response.status);
      // You can handle specific status codes if needed
      // if (error.response.status === 404) { ... }
      return { error: true, errorCode: error.response.status, msg: error.response.data?.error };
    } else {
      return { error: true, errorCode: null, msg: error.message };
    }
  }
}

/**
 * Generate a PDF report 
 * @param {Object} options
 * @param {string} options.templateId The ID of the template
 * @param {string} options.itemId The ID of the item (surveyParticipantId or surveyId)
 * @returns {Promise<string>} AWS S3 Presigned URL of the the generated PDF report
 */
const generateReport = async ({ templateId, itemId }) => {
  const idToken = store.getState().auth.idToken;
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_API_URL}/reports/v2/generate`,
      method: 'POST',
      headers: {
        Authorization: idToken
      },
      data: {
        options: {
          templateId,
        },
        itemId
      },
    })
    return response.data.url
  } catch (error) {
    return null
  }

}
export { getReportSignedUrl, generateReport, generateOverallReportItemId, getReportWebLink }